import { add } from "date-fns";
import React, {
  Fragment,
  memo,
  useCallback,
  useImperativeHandle,
  useMemo,
  useState,
  useRef,
} from "react";
import { useSelector } from "react-redux";
import {
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledButtonDropdown,
} from "reactstrap";
import { TOKEN_CLIENT_INFO } from "../../../../../actions/constants";
import {
  CHECK_CONFIRM,
  CHECK_CONFIRM_TIME,
} from "../../../../../components/alert/Alert";
import { FontAwesome } from "../../../../../components/icon";
import { BoSungVanDesEndpoint } from "../../../../../service/Meet";
import {
  Enums_Mau,
  _Enum_Trang_Thai_Noi_Dung,
  _Enum_Trang_Thai_Van_De,
} from "../../../../action/defaultEnums";
import ModalDanhGia from "./Modal/ModalDanhGia";
import ModalKetQua from "./Modal/ModalKetQua";
import { renderTrangThai } from "./util";
import { useAsync } from "../../../../../hooks";
import { randomCode } from "../../../../../actions/util";
import ModalVanDe from "./Modal/ModalVanDe";
import { Icon } from "@mui/material";

const dataInit = {
  isOpen: false,
  data: {},
};
const RenderButton = memo((props) => {
  const {
    item,
    dataND,
    index,
    isChuTri,
    isDienBien,
    _setIdVanDe,
    _setDataKQBQ,
    openReport,
  } = props;
  const [dataEdit, setDataEdit] = useState(dataInit);
  const { status, execute: exportReport } = useAsync(openReport, false);

  const thaoLuan = useCallback(async (item) => {
    const data = { trangThai: _Enum_Trang_Thai_Van_De.HoatDong };
    CHECK_CONFIRM_TIME({ titles: "Bắt đầu thảo luận vấn đề này?" }).then(
      (res) => {
        if (res) {
          if (!res?.value.noneTime) {
            const {
              value: { times },
            } = res;
            const ngayBatDau = new Date();
            const ngayKetThuc = add(new Date(), times);
            data.ngayBatDau = ngayBatDau;
            data.ngayKetThuc = ngayKetThuc;
          }
          BoSungVanDesEndpoint.editVanDes(item.id, data);
        }
      },
    );
  }, []);

  const ButtonResult = memo(({ id, onClick }) => {
    const a = Date.now();
    return (
      <Button
        className="action-btn action-btn-success"
        id={`${a}`}
        size="sm"
        onClick={onClick}
      >
        <FontAwesome fa="clipboard-list" />
        <span>Kết quả</span>
      </Button>
    );
  });

  // const buttonPDF = useCallback((item) => {
  //     return <ButtonIcon
  //         color='red'
  //         icon='file-pdf'
  //         onClick={() => exportReport({ khungNoiDungId: dataND?.id, boSungVanDeId: item?.id })}>
  //         {status === 'pending' ? <span className='d-flex'>Đang tải<div className="spinner-notify" /></span >
  //             : <span>pdf</span>}
  //     </ButtonIcon>
  // }, [dataND, exportReport, status])

  const modalVanDe = useMemo(() => {
    return (
      dataEdit?.isOpen && (
        <ModalVanDe
          isOpen={dataEdit.isOpen}
          isClose={() => setDataEdit((pre) => ({ data: null, isOpen: false }))}
          khungNoiDungId={dataND?.id}
          data={dataEdit.data}
        />
      )
    );
  }, [dataEdit, dataND]);

  const hanldeDelete = useCallback((item) => {
    CHECK_CONFIRM("Bạn chắc chắn muốn xóa").then((res) => {
      if (res && res.isConfirmed) {
        BoSungVanDesEndpoint.deleteVD(item.id);
      }
    });
  }, []);

  const renderButtonChuTri = useMemo(() => {
    if (item.trangThai === _Enum_Trang_Thai_Van_De.HoatDong) {
      return (
        <div className="action-btn-group">
          {isChuTri &&
            dataND?.trangThai === "DangHop" &&
            TOKEN_CLIENT_INFO?.mainRole !== "TK" && (
              <Button
                className="action-btn action-btn-primary"
                size="sm"
                onClick={() => _setIdVanDe(item.id)}
              >
                <FontAwesome fa="paper-plane" />
                <span>Trả lời</span>
              </Button>
            )}
          <ButtonResult
            id={index + "hd"}
            onClick={() => _setDataKQBQ(item, true)}
          />
        </div>
      );
    } else if (
      item.trangThai === _Enum_Trang_Thai_Van_De.HoanThanh ||
      isDienBien
    ) {
      return (
        <div className="action-btn-group">
          <UncontrolledButtonDropdown className="action-dropdown">
            <DropdownToggle className="action-dropdown-toggle">
              {status === "pending" ? (
                <div className="spinner-notify" />
              ) : (
                <FontAwesome fa="ellipsis-h" />
              )}
            </DropdownToggle>
            <DropdownMenu className="action-dropdown-menu">
              {TOKEN_CLIENT_INFO.mainRole !== "TK" && (
                <DropdownItem
                  className="action-dropdown-item action-dropdown-item-danger"
                  key="pdf"
                  onClick={() =>
                    exportReport({
                      khungNoiDungId: dataND?.id,
                      boSungVanDeId: item?.id,
                    })
                  }
                >
                  <FontAwesome fa="file-pdf" />
                  <span>Xuất file PDF</span>
                </DropdownItem>
              )}
              {TOKEN_CLIENT_INFO.mainRole !== "TK" && (
                <DropdownItem divider className="action-dropdown-divider" />
              )}
              <DropdownItem
                className="action-dropdown-item action-dropdown-item-success"
                key="result"
                onClick={() => _setDataKQBQ(item, true)}
              >
                <FontAwesome fa="clipboard-list" />
                <span>Kết quả</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledButtonDropdown>
        </div>
      );
    } else if (
      item.trangThai === _Enum_Trang_Thai_Van_De.Moi &&
      dataND &&
      dataND.trangThai === _Enum_Trang_Thai_Noi_Dung.DangHop &&
      !isDienBien
    ) {
      return (
        <div className="action-btn-group">
          <UncontrolledButtonDropdown className="action-dropdown">
            <DropdownToggle className="action-dropdown-toggle">
              <FontAwesome fa="ellipsis-h" />
            </DropdownToggle>
            <DropdownMenu className="action-dropdown-menu">
              <DropdownItem
                className="action-dropdown-item action-dropdown-item-info"
                key="thaoluan"
                onClick={() => thaoLuan(item)}
              >
                <Icon>note_alt</Icon>
                <span>Thảo luận</span>
              </DropdownItem>
              <DropdownItem divider className="action-dropdown-divider" />
              <DropdownItem
                className="action-dropdown-item action-dropdown-item-warning"
                key="edit"
                onClick={() =>
                  setDataEdit((pre) => ({ ...pre, isOpen: true, data: item }))
                }
              >
                <Icon>edit</Icon>
                <span>Sửa</span>
              </DropdownItem>
              <DropdownItem
                className="action-dropdown-item action-dropdown-item-danger"
                key="delete"
                onClick={() => hanldeDelete(item)}
              >
                <Icon>delete</Icon>
                <span>Xóa</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledButtonDropdown>
        </div>
      );
    } else {
      return <div></div>;
    }
  }, [
    _setDataKQBQ,
    _setIdVanDe,
    dataND,
    exportReport,
    hanldeDelete,
    index,
    isChuTri,
    isDienBien,
    item,
    status,
    thaoLuan,
  ]);

  const renderButtonCanBo = useMemo(() => {
    if (
      item.trangThai === _Enum_Trang_Thai_Van_De.HoatDong &&
      !isDienBien &&
      dataND &&
      dataND.trangThai === "DangHop"
    ) {
      return (
        <Button
          className="action-btn action-btn-primary"
          size="sm"
          onClick={() => _setIdVanDe(item.id)}
        >
          <FontAwesome fa="paper-plane" />
          <span>Trả lời</span>
        </Button>
      );
    } else if (
      item.trangThai === _Enum_Trang_Thai_Van_De.HoanThanh ||
      isDienBien ||
      dataND?.trangThai === "HoanThanh"
    ) {
      return (
        <div className="action-btn-group">
          <UncontrolledButtonDropdown
            direction="up"
            className="action-dropdown"
          >
            <DropdownToggle className="action-dropdown-toggle">
              {status === "pending" ? (
                <div className="spinner-notify" />
              ) : (
                <FontAwesome fa="ellipsis-h" />
              )}
            </DropdownToggle>
            <DropdownMenu className="action-dropdown-menu">
              <DropdownItem
                className="action-dropdown-item action-dropdown-item-danger"
                key="pdf"
                onClick={() =>
                  exportReport({
                    khungNoiDungId: dataND?.id,
                    boSungVanDeId: item?.id,
                  })
                }
              >
                <FontAwesome fa="file-pdf" />
                <span>Xuất file PDF</span>
              </DropdownItem>
              <DropdownItem divider className="action-dropdown-divider" />
              <DropdownItem
                className="action-dropdown-item action-dropdown-item-success"
                key="result"
                onClick={() => _setIdVanDe(item.id)}
              >
                <FontAwesome fa="clipboard-list" />
                <span>Kết quả</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledButtonDropdown>
        </div>
      );
    }
    return <Fragment />;
  }, [_setIdVanDe, dataND, exportReport, isDienBien, item, status]);

  return (
    <Fragment>
      {isChuTri ? renderButtonChuTri : renderButtonCanBo}
      {modalVanDe}
    </Fragment>
  );
});

const RenderTbodyCanBo = React.forwardRef((props, ref) => {
  const { isChuTri, idThanhPhanThamDu, vanDe, isDienBien } = props;
  const [_idVanDe, _setIdVanDe] = useState(null);
  const [_dataKQBQ, _setDataKQBQ] = useState(null);
  const { isUBND, noiDung: dataND } = useSelector(
    (state) => state.meetingRProcess,
  );
  const refKetQua = useRef();

  useImperativeHandle(
    ref,
    () => ({
      setDanhGia: (data) => _setIdVanDe(data),
      setKetQua: (data) => _setDataKQBQ(data),
      setCloseDanhGia: () => _setIdVanDe(null),
      setCloseKetQua: () => _setDataKQBQ(null),
    }),
    [],
  );
  const renderModalDanhGia = useMemo(() => {
    return (
      _idVanDe && (
        <ModalDanhGia
          isOpen={_idVanDe ? true : false}
          isClose={() => _setIdVanDe(null)}
          boSungVanDeId={_idVanDe}
          isDienBien={isDienBien}
          idThanhPhanThamDu={idThanhPhanThamDu}
        />
      )
    );
  }, [_idVanDe, idThanhPhanThamDu, isDienBien]);

  const renderModalKetQua = useMemo(() => {
    return (
      isChuTri && (
        <ModalKetQua
          ref={refKetQua}
          isOpen={_dataKQBQ}
          isClose={() => _setDataKQBQ(null)}
          _dataKQBQ={_dataKQBQ}
          isDienBien={isDienBien}
        />
      )
    );
  }, [_dataKQBQ, isChuTri, isDienBien]);

  return (
    <Fragment>
      <tbody className="voting-issues-tbody">
        {vanDe.length !== 0 ? (
          vanDe.map((item, index) => {
            const code = randomCode();
            const isActive =
              index === 0 &&
              item.trangThai === "HoatDong" &&
              dataND?.trangThai === "DangHop";
            const mauLabel =
              Enums_Mau.find((f) => f.value === item.mau)?.label || "BQ";

            return (
              <tr
                key={index + "VĐ"}
                className={`voting-issue-row ${isActive ? "active-issue" : ""} ${item.trangThai === "HoanThanh" ? "completed-issue" : ""}`}
              >
                <td className="issue-index">
                  <span className="index-badge">{index + 1}</span>
                </td>
                <td className="issue-name" id={`${code}`}>
                  <div className="issue-name-wrapper">
                    <span className="issue-text">{item.name}</span>
                  </div>
                </td>
                <td className="issue-type">
                  <span
                    className={`type-badge ${item.mau === "BQ" ? "type-bq" : "type-pa"}`}
                  >
                    {mauLabel}
                  </span>
                </td>
                <td className="issue-status">
                  {renderTrangThai(item.trangThai)}
                </td>
                {isUBND && (
                  <td className="issue-actions">
                    <RenderButton
                      key={"repect" + index}
                      {...{
                        ...props,
                        dataND,
                        item,
                        index: index + 1,
                        _setIdVanDe,
                        _setDataKQBQ,
                      }}
                    />
                  </td>
                )}
              </tr>
            );
          })
        ) : (
          <tr className="no-data-row">
            <td colSpan="5">
              <div className="no-data-content">
                <FontAwesome fa="inbox" className="no-data-icon" />
                <span>Chưa có vấn đề biểu quyết</span>
              </div>
            </td>
          </tr>
        )}
      </tbody>
      {renderModalDanhGia}
      {renderModalKetQua}
    </Fragment>
  );
});
export default RenderTbodyCanBo;
